import { canBroadcast } from 'lib/web/broadcastChannelUtils'

export type AssistantStreamSyncEventType = 'chat_stream_started' | 'chat_stream_settled'

export interface AssistantStreamSyncEvent {
  type: AssistantStreamSyncEventType
  chatId: number
  sourceId: string
  sentAt: number
}

const ASSISTANT_STREAM_SYNC_CHANNEL = 'trip-planner-assistant-stream-sync'
const TAB_SOURCE_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`

function isAssistantStreamSyncEvent(data: unknown): data is AssistantStreamSyncEvent {
  return data !== null &&
    typeof data === 'object' &&
    'type' in data &&
    (data.type === 'chat_stream_started' || data.type === 'chat_stream_settled') &&
    'chatId' in data &&
    typeof data.chatId === 'number' &&
    Number.isSafeInteger(data.chatId) &&
    data.chatId > 0 &&
    'sourceId' in data &&
    typeof data.sourceId === 'string' &&
    'sentAt' in data &&
    typeof data.sentAt === 'number'
}

export function publishAssistantStreamSyncEvent(type: AssistantStreamSyncEventType, chatId: number) {
  if (!canBroadcast()) return

  const channel = new BroadcastChannel(ASSISTANT_STREAM_SYNC_CHANNEL)
  channel.postMessage({
    type,
    chatId,
    sourceId: TAB_SOURCE_ID,
    sentAt: Date.now(),
  } satisfies AssistantStreamSyncEvent)
  channel.close()
}

export function subscribeAssistantStreamSyncEvents(
  onEvent: (event: AssistantStreamSyncEvent) => void,
) {
  if (!canBroadcast()) return () => {}

  const channel = new BroadcastChannel(ASSISTANT_STREAM_SYNC_CHANNEL)
  channel.onmessage = (event) => {
    if (!isAssistantStreamSyncEvent(event.data)) return
    if (event.data.sourceId === TAB_SOURCE_ID) return

    onEvent(event.data)
  }

  return () => {
    channel.close()
  }
}
